/**
 * Opens Elementor Popup 1047 and injects the video URL from the clicked button/link.
 * Supports:
 *  - Hosted videos (mp4/webm/ogg) → uses the <video> widget in the popup
 *  - YouTube (and Vimeo) → uses the <iframe> widget in the popup
 */
jQuery(document).ready(function ($) {
  const POPUP_ID = 1047; // Elementor popup ID where the video widgets live

  function isYouTubeUrl(url) {
    return /(youtube\.com\/.+|youtu\.be\/.+)/i.test(url);
  }

  function getYouTubeEmbedUrl(url) {
    try {
      // Normalize to embed URL with autoplay
      const u = new URL(url, window.location.origin);
      let videoId;
      if (u.hostname.includes('youtu.be')) {
        videoId = u.pathname.replace('/', '');
      } else {
        videoId = u.searchParams.get('v') || '';
      }
      if (!videoId) return null;
      const params = new URLSearchParams({
        autoplay: '1',
        rel: '0',
        playsinline: '1',
        enablejsapi: '1',
      });
      return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
    } catch {
      return null;
    }
  }

  function isVimeoUrl(url) {
    return /vimeo\.com\//i.test(url);
  }

  function getVimeoEmbedUrl(url) {
    try {
      const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
      if (!match) return null;
      const id = match[1];
      const params = new URLSearchParams({ autoplay: '1', dnt: '1' });
      return `https://player.vimeo.com/video/${id}?${params.toString()}`;
    } catch {
      return null;
    }
  }

  function isHostedVideo(url) {
    return /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);
  }

  function waitForPopupDom(popupId, cb, triesLeft = 40, intervalMs = 50) {
    const sel = `#elementor-popup-modal-${popupId}`;
    const attempt = () => {
      const $el = $(sel);
      if ($el.length) {
        cb($el);
      } else if (triesLeft > 0) {
        setTimeout(() => attempt(--triesLeft), intervalMs);
      }
    };
    attempt();
  }

  function openVideoModal() {
    if (typeof elementorProFrontend !== 'undefined' && elementorProFrontend.modules.popup) {
      elementorProFrontend.modules.popup.showPopup({ id: POPUP_ID, classes: 'elementor-video-modal' });
    }
  }

  function setupVideoInPopup(videoUrl) {
    waitForPopupDom(POPUP_ID, function ($modal) {
      // Find a host to insert our custom player inside the popup
      const $host = $modal.find('.elementor-' + POPUP_ID + ' .e-con-inner').first().length
        ? $modal.find('.elementor-' + POPUP_ID + ' .e-con-inner').first()
        : $modal.find('.dialog-widget-content').first();
      if (!$host.length) return;

      // Ensure a dedicated container exists for our player
      let $container = $modal.find('#agifly-video-player');
      if (!$container.length) {
        $container = $('<div id="agifly-video-player" class="agifly-video-player"></div>');
        // Simple 16:9 responsive wrapper via inline CSS for safety
        $container.css({ position: 'relative', width: '100%', maxWidth: '100%', margin: '0 auto' });
        $host.append($container);
      }

      // Clear any previous player nodes
      const cleanupPlayback = () => {
        try {
          const vid = $container.find('video').get(0);
          if (vid) {
            try {
              vid.pause();
            } catch {}
            // Remove src to free memory and stop network
            try {
              vid.removeAttribute('src');
              vid.load();
            } catch {}
          }
        } catch {}
        try {
          const $ifr = $container.find('iframe');
          if ($ifr.length) {
            $ifr.attr('src', 'about:blank');
          }
        } catch {}
        // Finally empty container
        try {
          $container.empty();
        } catch {}
      };

      // Prepare a responsive shell
      function makeResponsive(innerEl) {
        const $wrap = $('<div class="agifly-video-wrapper"></div>');
        // CSS: 16:9 aspect ratio using padding-top hack
        $wrap.css({ position: 'relative', width: '100%', paddingTop: '56.25%' });
        const $inner = $(innerEl);
        $inner.css({ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' });
        $wrap.append($inner);
        return $wrap;
      }

      // Build the appropriate player
      cleanupPlayback();

      if (isYouTubeUrl(videoUrl)) {
        const src = getYouTubeEmbedUrl(videoUrl) || videoUrl;
        const $iframe = $('<iframe>', {
          class: 'agifly-video-iframe',
          allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
          allowfullscreen: 'allowfullscreen',
          referrerpolicy: 'strict-origin-when-cross-origin',
          title: 'Video',
        });
        $iframe.attr('src', src);
        $container.append(makeResponsive($iframe));
      } else if (isVimeoUrl(videoUrl)) {
        const src = getVimeoEmbedUrl(videoUrl) || videoUrl;
        const $iframe = $('<iframe>', {
          class: 'agifly-video-iframe',
          allow: 'autoplay; fullscreen; picture-in-picture',
          allowfullscreen: 'allowfullscreen',
          referrerpolicy: 'strict-origin-when-cross-origin',
          title: 'Video',
        });
        $iframe.attr('src', src);
        $container.append(makeResponsive($iframe));
      } else if (isHostedVideo(videoUrl)) {
        const $video = $('<video>', {
          class: 'agifly-video-hosted',
          controls: true,
          autoplay: true,
          playsinline: true,
        });
        $video.attr('src', videoUrl);
        // Try to start playback
        try {
          const el = $video.get(0);
          const p = el.play();
          if (p && typeof p.then === 'function') {
            p.catch(() => {});
          }
        } catch {}
        $container.append(makeResponsive($video));
      } else {
        // Unknown: try iframe generic
        const $iframe = $('<iframe>', {
          class: 'agifly-video-iframe',
          allow: 'autoplay; fullscreen; picture-in-picture',
          allowfullscreen: 'allowfullscreen',
          referrerpolicy: 'strict-origin-when-cross-origin',
          title: 'Video',
        });
        $iframe.attr('src', videoUrl);
        $container.append(makeResponsive($iframe));
      }

      // Ensure cleanup when popup closes
      const onPopupHide = function () {
        const id = parseInt(arguments[1], 10);
        if (id === POPUP_ID) {
          cleanupPlayback();
          $(document).off('elementor/popup/hide', onPopupHide);
        }
      };
      $(document).on('elementor/popup/hide', onPopupHide);

      // Also bind close button in case event isn’t fired
      $modal.on('click.videoCleanup', '.dialog-lightbox-close-button', function () {
        cleanupPlayback();
        $modal.off('click.videoCleanup');
      });
    });
  }

  // Click handler: accept clicks on the button or the anchor inside
  $(document).on('click', '.button_open_popup, .button_open_popup a', function (e) {
    // Only prevent default if it’s an anchor navigation
    const $target = $(e.currentTarget);
    const $a = $target.is('a') ? $target : $target.find('a').first();
    const href = $a.attr('href');
    if ($a.length) {
      e.preventDefault();
    }

    if (!href) {
      // No URL, just open the popup as-is
      openVideoModal();
      return;
    }

    openVideoModal();
    setupVideoInPopup(href);
  });
});
